import { CustomSalaryComponent, CustomSalaryComponentsAction } from './types';

export const customSalaryComponentsReducer = (
  state: CustomSalaryComponent[],
  action: CustomSalaryComponentsAction,
): CustomSalaryComponent[] => {
  switch (action.type) {
    case 'COMPONENT_ADDED':
      return [...state, action.payload.component];

    case 'COMPONENT_DELETED':
      return state.filter((component) => component.id !== action.payload.id);

    case 'COMPONENT_UPDATED':
      return state.map((component) =>
        component.id === action.payload.id
          ? { ...component, ...action.payload.updates }
          : component,
      );

    case 'COMPONENT_AMOUNT_CHANGED':
      return state.map((component) =>
        component.id === action.payload.id
          ? { ...component, amount: action.payload.amount }
          : component,
      );

    case 'INITIALIZE_COMPONENTS':
      return action.payload.initialComponents;

    default:
      return state;
  }
};